import type { ReactNode } from 'react';

type StepLayoutProps = {
  children: ReactNode;
  description: string;
  title: string;
};

/**
 * Shared layout for wizard steps. Renders a consistent header (title + description)
 * followed by the step-specific content.
 */
export const StepLayout = ({ children, description, title }: StepLayoutProps) => (
  <div className="flex flex-col gap-7 ml-1 mb-1">
    <div className="flex flex-col">
      <h2 className="text-lg font-semibold leading-7 text-foreground">{title}</h2>
      <p className="text-sm leading-5 text-muted-foreground">{description}</p>
    </div>
    {children}
  </div>
);
